// extracted by mini-css-extract-plugin
module.exports = {"link":"_cb84bd","ratings":"_2383f7","rating":"_5b358f","tagline":"_8d4220"};